// Configuration constants for Twilio Chat and Sync services

export const MAX_MAP_PAGE_COUNT = 3;
export const MAX_ITEMS_PER_MAP_PAGE = 100; // 100 is Twilio's max
